var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-sex"},[_c('div',{staticClass:"title"},[_vm._v("最近一次下单时间：")]),_c('div',{staticClass:"tip"},[_vm._v("客户最近一次在商城里提交订单的时间")]),_c('div',{staticClass:"flex"},[_c('div',{staticStyle:{"margin-right":"10px"}},[_vm._v("最近一次下单在")]),_c('time-mod',{ref:"timeMod",attrs:{"disabled":_vm.disabled}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }